export const cleanForCSSIdentifier = (str: string) => {
  //In CSS, identifiers (including element names, classes, and IDs in selectors) can contain only
  //the characters [a-zA-Z0-9] and ISO 10646 characters U+00A0 and higher,
  //plus the hyphen (-) and the underscore (_); they cannot start with a digit, two hyphens, or a hyphen followed by a digit.

  // Step 1: Remove leading digits or replace with a prefix
  str = str.replace(/^[0-9]+/, "_");

  // Step 2: Replace invalid characters (anything that is not a letter, digit, underscore, or hyphen)
  str = str.replace(/[^a-zA-Z0-9_-]/g, "-");

  // Step 3: Ensure it doesn't start with a hyphen (optional)
  if (str.startsWith("-")) {
    str = "_" + str;
  }

  return str;
};
